// extracted by mini-css-extract-plugin
module.exports = {"content_forgotpass":"forgotpassword_content_forgotpass__37cAj","bg_forgotpass":"forgotpassword_bg_forgotpass__2aaMr","forgotpass_detail":"forgotpassword_forgotpass_detail__288dI"};